import { ContactMethods } from '../contact-methods';

export function FooterHero() {
  return (
    <div className="flex flex-col">
      <h2 className="font-heading text-4xl [@media(min-width:1055px)]:text-5xl [@media(min-width:1275px)]:text-6xl text-foreground mb-4 text-center [@media(min-width:1024px)]:text-left">
        Stop Managing. Start Growing.
      </h2>
      <p className="font-body text-lg [@media(min-width:1045px)]:text-xl [@media(min-width:1275px)]:text-2xl font-light text-muted-foreground leading-relaxed text-center [@media(min-width:1024px)]:text-left mb-4">
        Book 15 minutes. We'll show you what's possible.
      </p>
      <p className="font-body text-sm text-muted-foreground/70 font-light text-center [@media(min-width:1024px)]:text-left">
        Hire your digital workforce. AI workers, teams, and departments — monthly salary, included work budget, output guaranteed.
      </p>
      <div className="hidden [@media(min-width:1024px)]:block">
        <ContactMethods />
      </div>
    </div>
  );
}